var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("SoliForm", {
        ref: "form",
        staticClass: "safe-bottom",
        attrs: {
          title: _vm.contract?.product_name + " Agreement",
          mobileScroll: _vm.$vuetify.breakpoint.smAndDown ? true : false,
          textSubtitle: "",
          isSignature: "",
          subtitle: [],
          saveChanges: _vm.signed,
          screenCapture: false,
          loading: _vm.loading,
          eager: "",
          large: "",
          persistent: "",
          text: "I Agree",
          icon: "thumb_up",
        },
        on: {
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          submit: function ($event) {
            return _vm.saveSignature()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { staticClass: "pt-0" },
                      [
                        _vm.contract
                          ? _c(
                              "v-list",
                              _vm._l(
                                _vm.contract.contract_items,
                                function (term) {
                                  return _c(
                                    "v-list-item",
                                    { key: term.id },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticStyle: {
                                                "white-space": "normal",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  `${
                                                    term.item
                                                  }. ${_vm.getTextVariables(
                                                    term.title
                                                  )}`
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass: "pa-1",
                                              staticStyle: {
                                                "white-space": "normal",
                                                "min-height": "fit-content",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getTextVariables(
                                                    term.body
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-container",
                  [
                    _vm.loadSignature
                      ? _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              [
                                _c("VueSignaturePad", {
                                  ref: "signaturePad",
                                  staticClass: "signature",
                                  attrs: {
                                    width: "100%",
                                    height: "100px",
                                    options: { onEnd: _vm.onEnd },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-center ma-0 w-full",
                                  },
                                  [
                                    _vm.signatureImage
                                      ? _c("img", {
                                          staticClass:
                                            "signature justify-self-center",
                                          attrs: { src: _vm.signatureImage },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  {
                                    staticClass:
                                      "flex justify-center soli-blue-text mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "white",
                                        staticStyle: {
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Sign here\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.screenCapture
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "soli-blue-text",
                                        staticStyle: {
                                          position: "absolute",
                                          right: "16px",
                                          transform: "translateY(-15px)",
                                        },
                                        attrs: { small: "", color: "white" },
                                        on: { click: _vm.undoSignature },
                                      },
                                      [
                                        _c("v-icon", [_vm._v("undo")]),
                                        _vm._v("Undo"),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }